import { uuid } from '../../uuid'

export default {
    new(state) {
        state.start_id = uuid()
    }
}
